import { useComponentsContext } from "@blocknote/react";

import UIcon from "lib/icons/untitled_ui/UIcon";
import { useStotlesBlockNoteEditor } from "../useStotlesBlockNoteEditor";

export default function UndoButton() {
  const editor = useStotlesBlockNoteEditor();
  const Components = useComponentsContext();

  const handleUndo = () => {
    editor.undo();
  };

  if (!Components) {
    return <></>;
  }

  return (
    <Components.FormattingToolbar.Button
      label=""
      icon={<UIcon icon="reverseLeft" />}
      mainTooltip="Undo"
      onClick={handleUndo}
    />
  );
}
